

import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'




export default {
components: {
XHeader,
Tab,
TabItem
},
created(){
this.getMessage();
},

data () {
return {
tabIndex:0,
model:{pageSize:0},
messageList:[],
loading: false,
finished: false
}
},
methods: {
goBack(){
this.$router.push({
path : '/user/index',
query : {}
})
},
getMessage(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/muserMessage/getMessageList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.messageList = res.body.rows;
console.log(res.body.rows);
}
},function(res){
console.log(res.status);
});
},
changeMessage(i){
if(i==2){
this.model.messageStatus = null;
}
if(i==1 || i==0){
this.model.messageStatus = i;
}
this.getMessage();
},
onLoad() {

setTimeout(() => {
this.model.pageSize=this.model.pageSize+10;
this.$http.post(this.global.httpUrl + '/rest/v1/m/muserMessage/getMessageList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.messageList = res.body.rows;
console.log( res.body.dbTypes+111111111111);

this.loading = false;

if (this.messageList.length >= res.body.total) {
this.finished = true;
}
}
},function(res){
console.log(res.status);
});



}, 500);
},
}
}



// WEBPACK FOOTER //
// ./src/views/user/userMessage.vue